import type { JSX } from 'react';
import React from 'react';
import { createContext } from 'react';

import { BillingReportRow } from '../types';
import { LinkedServiceLine } from '../types/linked_service';

export interface AssociateBillingRowsContextInterface {
  highlightBillingRow: (billingRow: BillingReportRow) => void;
  removeLinkedServiceLine: (row: BillingReportRow) => void;
  linkedServiceLines: LinkedServiceLine[];
  setLinkedServiceLines: (linkedServiceLines: LinkedServiceLine[]) => void;
}

export const AssociateBillingRowsContext = createContext<AssociateBillingRowsContextInterface>({
  highlightBillingRow: (billingRow: BillingReportRow) => {
    console.log('highlightBillingRow', billingRow);
  },
  removeLinkedServiceLine: (row: BillingReportRow) => {
    console.log('removeLinkedServiceLine', row);
  },
  linkedServiceLines: [],
  setLinkedServiceLines: (linkedServiceLines: LinkedServiceLine[]) => {
    // MOCK IMPLEMENTATION
    console.log('setLinkedServiceLines', linkedServiceLines);
  }
});

export const AssociateBillingRowsProvider = ({
  value,
  children
}: {
  value: AssociateBillingRowsContextInterface;
  children: React.ReactNode;
}): JSX.Element => {
  return (
    <AssociateBillingRowsContext.Provider value={value}>
      {children}
    </AssociateBillingRowsContext.Provider>
  );
};
